import { supabase } from '@/integrations/supabase/client';

/**
 * Fire-and-forget product analytics. Never throws, never blocks UI.
 * Only emits in real mode (caller passes mode + dealershipId).
 */
export function track(
  event: string,
  ctx: { userId: string | null; dealershipId: string | null; mode: 'demo' | 'real' | null },
  properties: Record<string, unknown> = {},
) {
  if (ctx.mode !== 'real' || !ctx.userId || !ctx.dealershipId) return;
  // Defer to next tick so we never block the calling action.
  setTimeout(() => {
    supabase
      .from('usage_events')
      .insert({
        user_id: ctx.userId,
        dealership_id: ctx.dealershipId,
        event_name: event,
        properties: properties as never,
      })
      .then(({ error }) => {
        if (error && import.meta.env.DEV) {
          // eslint-disable-next-line no-console
          console.warn('[telemetry] failed to log', event, error.message);
        }
      });
  }, 0);
}
